function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useRef } from "react";
import { PostEditor } from "@sprout/client-components/dist/PostEditor";
import { formatToTipTapJSON } from "sprout-lib/dist/parser";
import { usePostPage_UpdateTodoListMutation } from "sprout-graphql";
import { useNavigationListListContext } from "@sprout/list-navigation";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { scrollPostIntoView } from "@sprout/client-components/dist/Post";
import useNewTodo from "../graphql/mutations/useNewTodo";
import { usePostPageEditor } from "../PostPageEditorContext";
const PostPageTodoEditor = (props)=>{
    const { topicId , open , todo: todo1 , parentId , parentType , parentNodeId , afterItemId , onClose ,  } = props;
    const { dispatch ,  } = usePostPageEditor();
    const closeEditor = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
        if (onClose) onClose();
    }, [
        dispatch,
        onClose
    ]);
    const { description  } = todo1 || {};
    const initialState = useMemo(()=>{
        return description ? formatToTipTapJSON(description, "BASIC").json : undefined;
    }, [
        description
    ]);
    const { setActiveItemId  } = useNavigationListListContext();
    const showSnackbar = useSnackbar();
    const history = useHistory();
    const pendingRef = useRef(false);
    const newTodoMutation = useNewTodo();
    const handleNew = useCallback(({ text , link , refocus =undefined , redirect =false  })=>{
        if (todo1) return;
        if (pendingRef.current) return;
        // start of mutation
        pendingRef.current = true;
        if (!refocus) closeEditor();
        if (refocus) refocus();
        if (!text.trim() && !link) {
            pendingRef.current = false;
            return;
        }
        const afterLastItem = afterItemId === undefined;
        const isLink = link !== null && link.startsWith("http");
        newTodoMutation({
            variables: {
                todoListId: parentId,
                // items_check6
                description: text || (link ? isLink ? null : link : ""),
                // items_check7
                url: isLink ? link : null,
                afterItemId,
                afterLastItem
            },
            parentId,
            parentNodeId,
            parentType
        }).then(({ data  })=>{
            var ref;
            const todo = data === null || data === void 0 ? void 0 : (ref = data.createItem) === null || ref === void 0 ? void 0 : ref.item;
            if (todo) {
                if (redirect) history.push(`/todo/${todo.id}`);
                else {
                    scrollPostIntoView(todo);
                    setActiveItemId(String(todo.id));
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        }).finally(()=>{
            pendingRef.current = false;
        });
    }, [
        afterItemId,
        closeEditor,
        history,
        newTodoMutation,
        parentId,
        parentNodeId,
        parentType,
        setActiveItemId,
        showSnackbar,
        todo1, 
    ]);
    const [updateTodoListMutation] = usePostPage_UpdateTodoListMutation();
    const handleUpdate = useCallback(({ text , link , todo  })=>{
        if (!text || !todo) {
            closeEditor();
            return;
        }
        if (description !== text) {
            const isLink = link !== null && link.startsWith("http");
            updateTodoListMutation({
                variables: {
                    itemId: todo.id,
                    // items_check6
                    description: text || (link ? isLink ? null : link : ""),
                    // items_check7
                    // We want to retain w/e the exiting link is, instead of removing it
                    url: isLink ? link : undefined
                },
                optimisticResponse: {
                    updateItemById: {
                        item: _objectSpread({}, todo, {
                            // items_check6
                            description: text || (link ? isLink ? null : link : ""),
                            // items_check7
                            // We want to retain w/e the exiting link is, instead of removing it
                            url: isLink ? link : null
                        }),
                        __typename: "UpdateItemPayload"
                    }
                }
            }).catch(()=>{
                showSnackbar.error();
            });
        }
        closeEditor();
    }, [
        closeEditor,
        description,
        showSnackbar,
        updateTodoListMutation
    ]);
    const handleEnter = useCallback(({ getStateAsText , clearState , focus  })=>{
        const { link , text  } = getStateAsText();
        if (todo1) handleUpdate({
            link,
            text,
            todo: todo1
        });
        else handleNew({
            refocus: afterItemId === undefined ? ()=>{
                clearState();
                focus();
            } : undefined,
            text,
            link
        });
        return true;
    }, [
        afterItemId,
        handleNew,
        handleUpdate,
        todo1
    ]);
    const handleSave = useCallback(({ getStateAsText  })=>{
        const { link , text  } = getStateAsText();
        if (todo1) handleUpdate({
            link,
            text,
            todo: todo1
        });
        else handleNew({
            redirect: true,
            text,
            link
        });
        return true;
    }, [
        handleNew,
        handleUpdate,
        todo1
    ]);
    const cancelButtonRef = useRef(null);
    const handleBlur = useCallback(({ getStateAsText  }, event)=>{
        if (event.relatedTarget === cancelButtonRef.current) return false;
        const { link , text  } = getStateAsText();
        if (todo1) handleUpdate({
            link,
            text,
            todo: todo1
        });
        else handleNew({
            text,
            link
        });
        return true;
    }, [
        handleNew,
        handleUpdate,
        todo1
    ]);
    const handleEscape = useCallback(({ blur  })=>{
        blur();
        return true;
    }, []);
    return /*#__PURE__*/ _jsx(PostEditor, {
        initialState: initialState,
        topicId: topicId,
        closeEditor: closeEditor,
        open: open,
        onEnter: handleEnter,
        onSave: handleSave,
        onBlur: handleBlur,
        onEscape: handleEscape,
        cancelButtonRef: cancelButtonRef
    });
};
export default PostPageTodoEditor;
